import { render, staticRenderFns } from "./AcceptTeamInvitation.vue?vue&type=template&id=335cffca&scoped=true&lang=pug&"
import script from "./AcceptTeamInvitation.vue?vue&type=script&lang=js&"
export * from "./AcceptTeamInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AcceptTeamInvitation.vue?vue&type=style&index=0&id=335cffca&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335cffca",
  null
  
)

/* custom blocks */
import block0 from "./AcceptTeamInvitation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports